import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli (Pirn) KV2002 machine

export default function TypeRow() {
   return (
      <InputRangeRow
         titleProp={"Type"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={99} //some default value
         propertyNameProp={"type"}
         errorDialogueProp={"Cannot be left empty"}
         floatProp={false}
         readOnlyProp={true}
      />
   );
}
